import React from "react";
import Layout3 from "components/layout/Layout3";
import Main from "./TVISettingsForm";

const AddTvi = (props) => {
  return (
    <Layout3>
      <Main {...props} />
    </Layout3>
  );
};

export default AddTvi;
